import React from "react";

export default function PwaInstallModal({ open, onInstall, onClose, isIOS }) {
  if (!open) return null;

  const handleOverlayClick = (e) => {
    // Fecha se clicar no overlay (fora do modal)
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleCloseClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onClose) onClose();
  };

  const handleInstallClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onInstall) onInstall();
  };

  return (
    <div style={overlay} onClick={handleOverlayClick}>
      <div style={modal}>
        <h3 style={heading}>Adicionar à tela inicial</h3>

        {isIOS ? (
          <p style={text}>
            No iPhone/iPad:
            <br />
            Toque em <strong>Compartilhar</strong> →{" "}
            <strong>Adicionar à Tela de Início</strong>
          </p>
        ) : (
          <p style={text}>Instale o app para acesso rápido.</p>
        )}

        <div style={actions}>
          {!isIOS && (
            <button
              onClick={handleInstallClick}
              onTouchEnd={handleInstallClick}
              style={primaryBtn}
              type="button"
            >
              Instalar
            </button>
          )}
          <button
            onClick={handleCloseClick}
            onTouchEnd={handleCloseClick}
            style={secondaryBtn}
            type="button"
          >
            Agora não
          </button>
        </div>
      </div>
    </div>
  );
}

const overlay = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: "rgba(0,0,0,0.8)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
  WebkitTapHighlightColor: "transparent",
};

const modal = {
  background: "#000",
  padding: "24px",
  borderRadius: "8px",
  border: "1px solid #D4AF37",
  maxWidth: "360px",
  width: "90%",
  textAlign: "center",
  position: "relative",
};

const heading = {
  color: "#fff",
  marginTop: 0,
  marginBottom: "16px",
};

const text = {
  color: "#fff",
  lineHeight: "1.6",
};

const actions = {
  display: "flex",
  justifyContent: "center",
  gap: "12px",
  marginTop: "16px",
};

const primaryBtn = {
  background: "#D4AF37",
  color: "#fff",
  border: "none",
  padding: "12px 24px",
  borderRadius: "4px",
  cursor: "pointer",
  fontSize: "16px",
  fontWeight: "500",
  WebkitTapHighlightColor: "transparent",
  touchAction: "manipulation",
};

const secondaryBtn = {
  background: "#555",
  color: "#fff",
  border: "none",
  padding: "12px 24px",
  borderRadius: "4px",
  cursor: "pointer",
  fontSize: "16px",
  fontWeight: "500",
  WebkitTapHighlightColor: "transparent",
  touchAction: "manipulation",
};
